import { getHourMinString } from "../../../../libs/dateFormat";

import { SpaceReservationItem } from "../../../../services/spaceReservationServices";

import ReservationBadge from "../../../../components/Badge/ReservationBadge";
import HorizontalRule from "../../../../components/Rule/Horizontal";
import TimeTable from "../../../../components/SpaceReservation/TimeTable";

type Props = {
  spaceReservation: SpaceReservationItem;
  onClick?: () => void;
};

export default function SpaceReservationListItem({
  spaceReservation,
  onClick,
}: Props) {
  return (
    <div
      key={spaceReservation.reservationSpaceId}
      onClick={onClick}
      className="flex flex-col rounded-[10px] border border-brand-neutral-15 cursor-pointer"
    >
      <div className="flex flex-row justify-between p-5">
        <div className="flex flex-col flex-basis-3/4">
          <div className="text-xl text-black font-semibold leading-6 design_min:w-[150px]">
            {spaceReservation.reservationSpaceName}
          </div>
          <div className="text-sm text-brand-neutral-50 font-normal leading-[18px] pb-[14px]">
            {spaceReservation.buildingFloorName ?? "-"}
          </div>

          <div
            className="flex flex-wrap gap-[5px] items-center"
            data-testid="reservation-item-badge"
          >
            <ReservationBadge
              active={spaceReservation.usePayment}
              children={spaceReservation.usePayment ? "유료" : "무료"}
            />
            <ReservationBadge
              children={`${spaceReservation.availablePeopleCountStart}~${spaceReservation.availablePeopleCountEnd}인`}
            />
            <ReservationBadge
              children={`최소 이용시간 ${getHourMinString(
                spaceReservation.usableTimeStart
              )}`}
            />
            {spaceReservation.usePayment !== true && (
              <ReservationBadge
                children={`최대 이용시간 ${getHourMinString(
                  spaceReservation.usableTimeEnd
                )}`}
              />
            )}
          </div>
        </div>
        <div className="flex flex-col flex-basis-1/4 gap-1.5">
          <div className="w-20 h-20">
            {spaceReservation.fileInfo?.items
              ?.filter((file) => file.scale === "small")
              .map((file, index) => (
                <img
                  className="object-cover w-full h-full rounded-md"
                  key={index}
                  src={file?.url}
                  alt={`${spaceReservation.reservationSpaceName}`}
                />
              ))}
          </div>
        </div>
      </div>
      <HorizontalRule margin="0" />
      <div className="w-full py-5 px-[17.5px]">
        <TimeTable
          key={spaceReservation.reservationSpaceId}
          size="small"
          availableTimeStart={spaceReservation.availableTimeStart}
          availableTimeEnd={spaceReservation.availableTimeEnd}
          spaceReservationData={spaceReservation.reservationList}
        />
      </div>
    </div>
  );
}
